import React from 'react';

export const InfoBoxItem: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <div className="flex items-center gap-xsmall py-xsmall">{children}</div>
);

export const InfoBoxRow: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <div className="mb-medium grid grid-cols-1 gap-small lg:grid-cols-2 lg:gap-xlarge">{children}</div>
);

export const InfoBoxColumn: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <div className="flex gap-small lg:gap-large [&_a]:text-[#6A6FF9] [&_a]:underline [&_a]:transition-colors hover:[&_a]:text-text-inverse hover:[&_a]:no-underline">
        {children}
    </div>
);

export const InfoBoxNumber: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <div className="flex h-[4rem] w-[4rem] min-w-[4rem] items-center justify-center rounded-full border border-solid border-brand-secondary/80 text-[1.6rem] font-bold text-[#A5A9FF] lg:h-[6rem] lg:w-[6rem] lg:min-w-[6rem] lg:text-[2.4rem]">
        {children}
    </div>
);
